module.exports = __webpack_public_path__ + "static/barbecue-103983984189f1541b3d4e048b437ceb.svg";